import styled from 'styled-components';
import { layout, media } from '@prisjakt/ui-base';
import ChevronRight from 'mdi-react/ChevronRightIcon';
import { H3Text } from '@prisjakt/ui/text/variants';

export const WordCloudH3 = styled(H3Text)`
  margin-bottom: ${layout.measurements.spacing125};
`;

export const WordCloudContainer = styled.ul`
  margin: 0 ${layout.pageContent.gutter.rem};
  margin-bottom: ${layout.measurements.spacing125};

  ${media.mediumDown`
    margin: 0;
    margin-bottom: ${layout.measurements.spacing150};
    padding: ${layout.measurements.spacing150} ${layout.pageContent.gutter.rem};
  `}
`;

export const ShowMoreButton = styled.li`
  flex: 0;
  max-width: 250px;
  margin: 4px;
`;

export const ShowMoreIcon = styled(ChevronRight)`
  height: 16px;
  width: 16px;
`;
